var tables = document.querySelectorAll('table');

// Wrap all tables in table wrapper to force scrolling if table is too wide
[].forEach.call(tables, function(table) {
    var wrapper = document.createElement('div');
    wrapper.classList.add('table__wrapper');
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
});
